<div class="p-fluid">
  <div class="form-box">
    <label for="name">Name</label>
    <input pInputText id="name" [formControl]="itemName" class="w-full" [disabled]="!canEdit" />
  </div>

  <div class="mt-5 row-end-center gap-5">
    <button pButton [label]="'Common_Cancel' | translateWF: 'Cancel'" class="p-button-text" (click)="onCancel()"></button>
    @if (canEdit) {
      <button pButton [label]="'Common_Save' | translateWF: 'Save'" class="p-button-primary" (click)="onSave()"></button>
    }
  </div>
</div>
